export const Title = ({ children }: { children?: React.ReactNode }) => {
  return (
    <h1 className='text-lg md:text-2xl'>{children}</h1>
  )
}

export const Subtitle = ({ children }: { children?: React.ReactNode }) => {
  return (
    <h2 className='md:text-xl mt-8'>{children}</h2>
  )
}

export const BoldHeader3 = ({ children }: { children?: React.ReactNode }) => {
  return (
    <h3 className='text-sm md:text-base font-bold'>{children}</h3>
  )
}